import React from "react";
import { useAuthContext } from "../../context/auth";

function PortraitProgramLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col h-full w-full bg-bg">
      <div className="flex h-[160px] justify-center px-[70px] items-center border-b border-border">
        <img className="w-[340px]" src="/logo.png" alt="logo" />
      </div>
      <div className="flex-1">{children}</div>
      <div
        className="h-[64px] flex items-center justify-center"
        style={{
          background:
            "var(--GMOHOB2, linear-gradient(135deg, #FFEFD6 0%, #D7B98B 100%))",
        }}
      >
        <p className="text-[#48505F] text-[32px]">Hole Body Movement</p>
      </div>
    </div>
  );
}

export default PortraitProgramLayout;
